export const TipAlignments = {
  center: 'center',
  end: 'end',
  start: 'start',
};

export const TipDirections = {
  bottom: 'bottom',
  left: 'left',
  top: 'top',
  right: 'right',
};

export const alignments = Object.values(TipAlignments);
export const directions = Object.values(TipDirections);
